/**
 * avatars/presets/textures/torso.js
 * Sinh texture thân áo (Torso Texture) - Dispatcher Registry
 */

import { TORSO_REGISTRY } from './torso/index.js';

// Các outfit được ưu tiên hơn cờ isLabCoat (đứng trước nhánh isLabCoat trong chuỗi if/else gốc)
const OUTFITS_BEFORE_LAB_COAT = new Set([
  'ao_dai',
  'ao_ba_ba',
  'hoc_sinh_vn',
  'grab',
  'be',
  'xanh_sm',
  'suit',
  'ao_ba_lo',
  'shopee',
  'bao_ve',
  'so_mi_can_bo',
  'genz_oversize',
  'tien_loi'
]);

export function generateTorsoTexture(ctx, size, options = {}) {
  const outfit = options.outfit || 'default';
  const defaultColor = outfit === 'ao_dai' ? '#ffffff' : '#0284c7';
  const mainColor = options.shirtColor || defaultColor;

  // Nền áo cơ bản
  ctx.fillStyle = mainColor;
  ctx.fillRect(0, 0, size, size);

  // Dispatcher vẽ chi tiết trang phục theo Registry Pattern.
  // Giữ đúng thứ tự của chuỗi if/else gốc: cờ isLabCoat nằm SAU các outfit Việt Nam
  // nhưng TRƯỚC các outfit alien; 'lab_coat' không phải là key outfit trong chuỗi gốc.
  const drawer = outfit !== 'lab_coat' ? TORSO_REGISTRY[outfit] : null;
  if (drawer && (!options.isLabCoat || OUTFITS_BEFORE_LAB_COAT.has(outfit))) {
    drawer(ctx, size, options);
  } else if (options.isLabCoat) {
    TORSO_REGISTRY.lab_coat(ctx, size, options);
  }
}
